import { CenterTripDistribution } from '../../../lib/types/models/center/center-distributions'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterSecondaryTripDistribution(id: number, journeyId?: number) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getSecondaryTripDistribution.url, { id }), {
        journeyId
      })
    )
    .get<CenterTripDistribution[]>()
}
